import Link from 'next/link'

import { DirectoryLinkAs, DirectoryLinkHref, Reset } from 'utils/DirectoryParser'
import { FlexDiv, P } from 'components/generic/HomePageComponents'
import TextInput from 'components/Directories/SearchFacetsContainer/TextInput'
import SearchInputs from 'components/Directories/SearchFacetsContainer/SearchInputs'
import { PHover } from 'components/Directories/SearchFacetsContainer/Styled'

const SEARCH_PROMPT = 'Search by Keyword'

const LargeSearchContainer = ({
  siteDirectoryResultsTypes,
  directoryResultsType,
  keyword,
  directoryLinkInformation,
  resetFilters,
}) => {
  const resetDirectoryLinkInformation = Reset(directoryLinkInformation, siteDirectoryResultsTypes)
  const href = DirectoryLinkHref(resetDirectoryLinkInformation)
  const as = DirectoryLinkAs(resetDirectoryLinkInformation)
  return (
    <>
      <FlexDiv justifyContent='space-between'>
        <P lineHeight='20px' fontWeight='bold' fontSize='14px'>
          Search for:
        </P>
        <Link scroll={false} href={href} as={as}>
          <PHover onClick={resetFilters}>Reset Filters</PHover>
        </Link>
      </FlexDiv>
      <SearchInputs
        siteDirectoryResultsTypes={siteDirectoryResultsTypes}
        directoryLinkInformation={directoryLinkInformation}
        directoryResultsType={directoryResultsType}
      />
      <TextInput
        placeholder={SEARCH_PROMPT}
        textValue={keyword}
        directoryLinkInformation={directoryLinkInformation}
      />
    </>
  )
}

export default LargeSearchContainer
